import { useEffect } from 'react';
import {
  Outlet,
  useMatch,
  useNavigate,
  useOutletContext,
} from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { PermissionDenied, PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';

import ROUTES from '../../routes';

import commonStyles from '../common/common.module.css';

const Corporate = (): React.JSX.Element => {
  const navigate = useNavigate();

  const { activePermissions } = useAppSelector((state) => state.root);

  const { sendMessage } = useOutletContext<{
    sendMessage: SendMessage | null;
  }>();

  const match = useMatch(ROUTES.CUSTOMERS_CORPORATE);

  useEffect(() => {
    if (
      match &&
      activePermissions?.includes(PermissionEnum.CORPORATE_CUSTOMERS_LIST)
    ) {
      navigate(ROUTES.CUSTOMERS_CORPORATE_LIST);
    }
  }, [match, activePermissions]);

  useEffect(() => {
    let title = 'Corporate Customers';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content;

  if (!activePermissions?.includes(PermissionEnum.CORPORATE_CUSTOMERS_LIST)) {
    content = <PermissionDenied />;
  } else {
    content = (
      <div className={commonStyles.customers}>
        <Outlet context={{ sendMessage }} />
      </div>
    );
  }

  return content;
};

export default Corporate;
